interface UploadFormDataOptions {
  headers?: Record<string, string>;
  onProgress?: (progress: number) => void;
  onUploadComplete?: () => void;
}

export const uploadFormDataWithProgress = <T>(
  url: string,
  formData: FormData,
  { headers = {}, onProgress, onUploadComplete }: UploadFormDataOptions = {},
): Promise<T> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    let isUploadCompleteNotified = false;

    Object.entries(headers).forEach(([key, value]) => {
      xhr.setRequestHeader(key, value);
    });

    xhr.upload.addEventListener("progress", (event) => {
      if (!event.lengthComputable || event.total <= 0) {
        return;
      }

      const progress = Math.min(100, Math.round((event.loaded / event.total) * 100));
      onProgress?.(progress);

      if (!isUploadCompleteNotified && event.loaded >= event.total) {
        isUploadCompleteNotified = true;
        onUploadComplete?.();
      }
    });

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText) as T);
        } catch {
          reject(new Error("Invalid server response"));
        }
        return;
      }

      reject(new Error(xhr.responseText || `Upload failed with status ${xhr.status}`));
    });

    xhr.addEventListener("error", () => {
      reject(new Error("Network error during upload"));
    });

    xhr.addEventListener("abort", () => {
      reject(new Error("Upload aborted"));
    });

    xhr.send(formData);
  });
